import { SelectOptionInstruction } from '../SelectOptionInstruction'

export class DistrictInstruction extends SelectOptionInstruction {
  constructor ({ option, waitForNoLoaders, label }) {
    super({
      name: 'District',
      option,
      waitForNoLoaders: waitForNoLoaders === undefined ? true : waitForNoLoaders,
      label

    })
  }

  setDefaultValue (params) {
    this.option = params.addressInformation.district
  }
}
